var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"leaflink-logo",attrs:{"alt":"LeafLink Logo","width":_vm.width,"src":require('@/assets/img/provider/leaflink-logo-text-black.svg')},on:{"click":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }